export default "__VITE_ASSET__nEZDY4AJiMya1ACAasgb4g__"